(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["maxistock-pro-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('.maxistock-pro-menu--mobile a');
  if (!link) return;
  const drawer = link.closest('.offcanvas-header');
  const close = drawer && drawer.querySelector('.offcanvas__close_btn');
  if (close) close.click();
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pro-form-labels"] && !Shopify.designMode) return;
  try {
    (() => {
  let attempts = 0;
  function styleProForm() {
    const host = document.querySelector('.pro-form shopify-forms-embed, .maxistock-pro-application shopify-forms-embed');
    const root = host?.shadowRoot;
    if (!root?.querySelector('[id="custom#type_zaak-selector-label"]')) {
      if (++attempts < 120) setTimeout(styleProForm, 250);
      return;
    }
    if (root.querySelector('[data-pro-form-labels]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-pro-form-labels', '');
    style.textContent = `
      section[class*="_inline_"] {box-sizing:border-box;padding:2px;}
      section[class*="_formContainer_"] {box-sizing:border-box;width:100%;max-width:100%;margin:0;}
      [class*="_formDisclaimer_"] {font-size:13px;line-height:1.5;margin-top:12px;color:#082E3F;}
      [class*="_formDisclaimer_"] p {font-family:Body-Font,sans-serif!important;font-size:13px!important;line-height:1.5!important;margin:0;}
      [class*="_formDisclaimer_"] a {font:inherit!important;color:#235E4C;text-decoration:underline;text-underline-offset:2px;}
      [id="custom#type_zaak-selector-label"] {
        position:absolute;top:15px;left:15px;z-index:1;margin:0;
        pointer-events:none;font-size:16px;line-height:20px;color:#082E3F;
      }
      button[aria-labelledby="custom#type_zaak-selector-label custom#type_zaak-selector-value"] {min-height:50px;}
      div:has(> [id="custom#type_zaak-selector-label"]):has([id="custom#type_zaak-selector-value"]:not(:empty)) > p {
        top:4px;font-size:11px;line-height:14px;
      }
      button:has(> [id="custom#type_zaak-selector-value"]:not(:empty)) {padding-top:22px;padding-bottom:8px;}
    `;
    root.appendChild(style);
    const consent = root.querySelector('input[name="emailConsent"]')?.closest('[class*="_consentCheckboxContainer_"]');
    const submit = root.querySelector('button[type="submit"]');
    if (consent && submit && consent.parentElement === submit.parentElement) {
      submit.before(consent);
    }
    const privacy = host.closest('.pro-form, .maxistock-pro-application')?.querySelector('.pro-form-privacy');
    const disclaimer = root.querySelector('[class*="_formDisclaimer_"] p');
    if (privacy?.querySelector('a') && disclaimer) {
      disclaimer.append(' ', privacy.querySelector('a').cloneNode(true));
      privacy.hidden = true;
    }
  }
  styleProForm();
})();
  } catch(e) { console.error(e); }
})();

})();
